export const cibConekta = ["32 32","<path d='M11 26.005l-7.401-10.005 7.401-10 4.599 6.198-3.005 3.802 3 4-4.599 6.005zM16.599 32l11.802-16-11.802-16h-9.198l12 16-12 16z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/brand/cib-conekta.js
// module id = null
// module chunks = 